import { Injectable } from '@angular/core';
import { FileTransfer } from '@capacitor/file-transfer';
import { FileViewer } from '@capacitor/file-viewer';
import { Directory, Filesystem } from '@capacitor/filesystem';

@Injectable({ providedIn: 'root' })
export class FileService {
	/**
	 * Download a file from a server
	 */
	async downloadFile(url: string, name: string) {
		const info = await Filesystem.getUri({
			directory: Directory.Documents,
			path: name,
		});

		return FileTransfer.downloadFile({
			url,
			path: info.uri,
			progress: true,
		});
	}

	openDocument(path: string) {
		return FileViewer.openDocumentFromLocalPath({ path });
	}
}
